/**
 * MedCaddy API Client - Audit Module
 * Handles audit log listing and resource history.
 */

import { apiFetch, assertOk } from './core';

// Audit API
export const audit = {
  async list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.action) params.append('action', filters.action);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const response = await apiFetch(`/audit?${params}`);
    assertOk(response, 'Failed to fetch audit logs');
    return response.json();
  },

  async resourceHistory(resourceType, resourceId) {
    const response = await apiFetch(`/audit/resource/${resourceType}/${resourceId}`);
    assertOk(response, 'Failed to fetch resource audit logs');
    return response.json();
  }
};
